import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {WorkOrderService} from '../../../Services/work-order.service';
import {BsToastService} from '../../../Services/bs-toast-service';

@Component({
  selector: 'app-work-orders-schedule',
  templateUrl: './work-orders-schedule.component.html',
  standalone: false,
})
export class WorkOrdersScheduleComponent implements OnInit {

  workOrders: any[] = [];
  isLoaded = false;
  fromDate = '';
  toDate = '';
  userId = '';

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    private router: Router,
  ) {
    const now = new Date();
    this.fromDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay()).toISOString().substring(0, 10);
    this.toDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 6).toISOString().substring(0, 10);
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoaded = false;
    const params: any = {from_date: this.fromDate, to_date: this.toDate};
    if (this.userId) {
      params.user_id = this.userId;
    }
    console.log('[WO Schedule] GET api/WorkOrder/schedule params:', params);
    this.woService.getSchedule(params).subscribe({
      next: (res: any) => {
        console.log('[WO Schedule] response', res);
        this.workOrders = Array.isArray(res) ? res : (res?.Data ?? res?.data ?? res ?? []);
        this.isLoaded = true;
      },
      error: () => {
        this.notification.showErrorToast('Error loading schedule.');
        this.isLoaded = true;
      }
    });
  }

  statusClass(status: string): string {
    switch (status) {
      case 'Open':
        return 'bg-primary';
      case 'Dispatched':
        return 'bg-warning text-dark';
      case 'In Progress':
        return 'bg-info text-dark';
      case 'Completed':
        return 'bg-success';
      default:
        return 'bg-secondary';
    }
  }

  generateInvoice(wo: any): void {
    this.router.navigate(['/transactions/invoice/ar/form'], {queryParams: {invoiceId: 'newAR', workorderId: wo.id}});
  }

  goToWo(id: string): void {
    this.router.navigate(['/work-orders/work-orders-form'], {queryParams: {id}});
  }

  newWo(): void {
    this.router.navigate(['/work-orders/work-orders-form']);
  }
}
